import React, { useEffect, useCallback } from 'react';
import '../less/index.less';

const Modal = ({ isOpen, onClose, title, qrCodeSrc }) => {
  const handleEscKey = useCallback((event) => {
    if (event.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
    } else {
      document.removeEventListener('keydown', handleEscKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, handleEscKey]);

  const handleOverlayClick = (event) => {
    if (event.target.className === 'modal-overlay') {
      onClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={handleOverlayClick} onKeyDown={(e) => e.key === 'Enter' && handleOverlayClick} tabIndex="0">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        <h2 className="modal-title" dangerouslySetInnerHTML={{__html: title}}></h2>
        <div className="modal-qr-wrapper">
          <img src={qrCodeSrc} alt="QR Code" className="modal-qrcode" />
        </div>
      </div>
    </div>
  );
};

export default Modal;